import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { installIdentityInterceptor, installPermissionInvalidation } from './comman/http';
import { clearPermissions } from './comman/permissions';

// Before anything renders: every request the app makes says who is making it. See comman/http.js.
installIdentityInterceptor();
// Saving one of the permission masters drops the cached copy, so the change is seen on the next
// navigation rather than when the copy expires.
installPermissionInvalidation(clearPermissions);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
